import { useTranslation } from "react-i18next";
import { useState } from "react"
import { Modal, Button } from "../../ui/ot"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../../ui/ot'
import { useNavigate } from "react-router-dom"

const CardView = ({
    card = <></>,
    marc = <></>,
    record,
    permission_level = null, 
    ...props
}) => {
    const { t } = useTranslation('translation')
    const i18nPrefix = "library.cardView."
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [mode, setMode] = useState('marc')
    const onMARCClick = () => {
        setOpen(true)
        setMode('marc')
    }
    const onCardClick = () => {
        setOpen(true)
        setMode('card')
    }
    return <>
        <div className="flex items-center   rounded">
            {/* <button variant='ghost' className="px-2 py-1 border-r border-gray-300" onClick={() => setOpen(true)}>書目預覽</button> */}
            {permission_level === 1 ? 
            <button variant='ghost' className="px-2 py-1 border-r border-gray-300"
                style={{ color: '#fa8c16' }}
                onClick={() => {
                    navigate('/library/backstage/AddMARC?defaultEditMode=marc21', { state: record })
                }}>
                {/* {t("import")} */}
                書目匯入
            </button>
            : <></>}
            <button variant='ghost' className="px-2 py-1 border-r border-gray-300" onClick={onMARCClick}>
                Marc 預覽
            </button>
            <button variant='ghost' className="px-2 py-1 border-r border-gray-300" onClick={onCardClick}>書目預覽</button>
            {/* <DropdownMenu>
                <DropdownMenuTrigger>
                    <button className="px-2 py-1 flex items-center justify-center " style={{ color: '#fa8c16' }} onClick={() => setOpen(true)}>
                        更多操作
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent>
                    <DropdownMenuItem onClick={onMARCClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-eye" viewBox="0 0 16 16">
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                        </svg>
                        Marc 預覽
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={onCardClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-eye" viewBox="0 0 16 16">
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                        </svg>
                        書目預覽
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        onClick={() => {
                            navigate('/library/backstage/AddMARC', { state: record })
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-download" viewBox="0 0 16 16">
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                        </svg>
                        {t("import")}
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu> */}
        </div>
        <Modal
            open={open}
            title={t(`${i18nPrefix}TitlePreview`)}
            close
            closeText="關閉"
            onClose={() => { setOpen(false) }}
        >
            {mode === 'marc' && marc}
            {mode === 'card' && card}
        </Modal>
    </>
}
export default CardView